"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("./constants");

var _logger = console;
var _logVerbosity = constants_1.LogVerbosity.DEBUG;

exports.getLogger = function () {
  return _logger;
};

exports.setLogger = function (logger) {
  _logger = logger;
};

exports.setLoggerVerbosity = function (verbosity) {
  _logVerbosity = verbosity;
}; // tslint:disable-next-line no-any


exports.log = function (severity) {
  if (severity >= _logVerbosity && typeof _logger.error === 'function') {
    var _logger2;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    (_logger2 = _logger).error.apply(_logger2, args);
  }
};